import type {
    ActiveImplantSystem,
    ActiveSystemSummary,
} from '@nordinsight/implant-core/contracts';
import { GETREQUESTOPTIONS, instance } from '../apiService';

export const getActivePickerSystems = async (): Promise<
    ActiveSystemSummary[]
> => {
    const response = await instance.get(
        '/api/active-systems/picker',
        GETREQUESTOPTIONS()
    );
    return response.data.data;
};

export interface ActivePickerSystemResult {
    system: ActiveImplantSystem;
    /** Epoch ms when the earliest embedded signed file URL expires; refetch
     *  before then to keep documents/images loadable (see FileLink). */
    filesExpireAt: number | null;
}

export const getActivePickerSystem = async (
    id: string
): Promise<ActivePickerSystemResult> => {
    const response = await instance.get(
        `/api/active-systems/picker/${id}`,
        GETREQUESTOPTIONS()
    );
    return {
        system: response.data.data,
        filesExpireAt: response.data.filesExpireAt ?? null,
    };
};

export interface ResolvedActiveSystem {
    id: string;
    /** Normalized (upper-case) code, as stored. */
    mriCode: string;
}

/** Look up an active system by its MRI code (`<INITIALS>-A-<N>`). Null when
 *  unknown — or when the request fails, so a missing server-side flag never
 *  breaks the search page that calls this speculatively. */
export const resolveActiveSystemByMriCode = async (
    code: string
): Promise<ResolvedActiveSystem | null> => {
    try {
        const response = await instance.get(
            `/api/active-systems/picker/resolve/${encodeURIComponent(code)}`,
            GETREQUESTOPTIONS()
        );
        return response.data.data ?? null;
    } catch {
        return null;
    }
};
